import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "46",
  height: "46",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "40",
      height: "40",
      x: "3",
      y: "3",
      fill: "#F2F4F7",
      rx: "20"
    }, null, -1 /* HOISTED */),
    _createElementVNode("rect", {
      width: "40",
      height: "40",
      x: "3",
      y: "3",
      stroke: "#F9FAFB",
      "stroke-width": "6",
      rx: "20"
    }, null, -1 /* HOISTED */),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M20.917 16.333a5.417 5.417 0 0 0-3.838 9.24.833.833 0 1 1-1.18 1.177 7.083 7.083 0 1 1 11.03-8.747 5.417 5.417 0 0 1 3.268 9.592.833.833 0 1 1-1.06-1.285 3.75 3.75 0 0 0-2.386-6.643 1.35 1.35 0 0 1-1.164-.662 5.414 5.414 0 0 0-4.67-2.672Zm1.494 6.078a.833.833 0 0 1 1.178 0l3.334 3.333a.833.833 0 1 1-1.179 1.179l-1.91-1.911V30.5a.833.833 0 0 1-1.667 0v-5.488l-1.911 1.91a.833.833 0 0 1-1.178-1.178l3.333-3.333Z",
      "clip-rule": "evenodd"
    }, null, -1 /* HOISTED */)
  ])))
}
export default { render: render }